module.exports = __webpack_public_path__ + "assets/img/fuguoing5.08872fe3.png";